var _excluded = ["previewHeight", "viewMoreLabel", "viewLessLabel", "onResizeFinished", "featureList"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Collapse } from 'react-collapse';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { Features } from './features';
import * as styles from './listing-description.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TIMEOUT = 50;
var SIZE_OFFSET = 38;
var SERVER_RENDERED_DESCRIPTION_LENGTH = 410;
export var ListingDescription = _ref => {
  var _props$description;
  var _ref$previewHeight = _ref.previewHeight,
    previewHeight = _ref$previewHeight === void 0 ? 150 : _ref$previewHeight,
    _ref$viewMoreLabel = _ref.viewMoreLabel,
    viewMoreLabel = _ref$viewMoreLabel === void 0 ? 'View more' : _ref$viewMoreLabel,
    _ref$viewLessLabel = _ref.viewLessLabel,
    viewLessLabel = _ref$viewLessLabel === void 0 ? 'View less' : _ref$viewLessLabel,
    _ref$onResizeFinished = _ref.onResizeFinished,
    onResizeFinished = _ref$onResizeFinished === void 0 ? () => {} : _ref$onResizeFinished,
    _ref$featureList = _ref.featureList,
    featureList = _ref$featureList === void 0 ? [] : _ref$featureList,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var serverRenderedDescription = (_props$description = props.description) === null || _props$description === void 0 ? void 0 : _props$description.substring(0, SERVER_RENDERED_DESCRIPTION_LENGTH);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLongDescription = _useState4[0],
    setLongDescription = _useState4[1];
  var _useState5 = useState(props.clientRendered ? serverRenderedDescription : props.description),
    _useState6 = _slicedToArray(_useState5, 2),
    description = _useState6[0],
    setDescription = _useState6[1];
  var descriptionRef = useRef(null);
  var contentBlock = useRef(null);
  var container = useRef(null);
  var timer = useRef();
  var isDescriptionTextLong = props.description.length > SERVER_RENDERED_DESCRIPTION_LENGTH;
  var updateLongDescription = useCallback(() => {
    var _descriptionRef$curre;
    setLongDescription((((_descriptionRef$curre = descriptionRef.current) === null || _descriptionRef$curre === void 0 ? void 0 : _descriptionRef$curre.clientHeight) || 0) > previewHeight);
  }, [descriptionRef, previewHeight]);
  useEffect(() => {
    updateLongDescription();
  }, [updateLongDescription]);
  useEffect(() => () => global.clearTimeout(timer.current), []);
  useEffect(() => {
    window.addEventListener('resize', updateLongDescription);
    return () => window.removeEventListener('resize', updateLongDescription);
  });
  var handleResizeProgress = () => {
    var _container$current$cl, _container$current, _contentBlock$current, _contentBlock$current2;
    var containerHeight = (_container$current$cl = (_container$current = container.current) === null || _container$current === void 0 ? void 0 : _container$current.clientHeight) !== null && _container$current$cl !== void 0 ? _container$current$cl : 0;
    var contentHeight = (_contentBlock$current = (_contentBlock$current2 = contentBlock.current) === null || _contentBlock$current2 === void 0 ? void 0 : _contentBlock$current2.clientHeight) !== null && _contentBlock$current !== void 0 ? _contentBlock$current : 0;
    if (isOpened ? containerHeight >= contentHeight : containerHeight <= previewHeight + SIZE_OFFSET) {
      onResizeFinished();
    } else {
      timer.current = global.setTimeout(() => handleResizeProgress(), TIMEOUT);
    }
  };
  var toggleOpenDescription = () => {
    if (props.clientRendered) {
      setDescription(isOpened ? serverRenderedDescription : props.description);
    }
    setIsOpened(!isOpened);
  };
  var handleViewClick = () => {
    if (!isOpened) {
      sendEvent('show-more');
    }
    toggleOpenDescription();
  };
  var isCollapsible = props.clientRendered && isDescriptionTextLong || !props.clientRendered && isLongDescription;
  return ___EmotionJSX("div", {
    css: styles.description,
    "data-testid": "description"
  }, isCollapsible ? ___EmotionJSX("div", {
    ref: container,
    css: styles.collapse(previewHeight)
  }, ___EmotionJSX(Collapse, {
    isOpened: isOpened,
    onWork: handleResizeProgress
  }, ___EmotionJSX("section", {
    ref: contentBlock
  }, ___EmotionJSX("div", {
    ref: descriptionRef,
    css: styles.content,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), ___EmotionJSX(Features, {
    features: featureList
  })), !isOpened && ___EmotionJSX("div", {
    css: styles.fade
  })), ___EmotionJSX(Button, {
    css: styles.descriptionButton,
    appearance: "outline",
    size: "small",
    icon: isOpened ? ___EmotionJSX(ChevronUpIcon, {
      size: "small"
    }) : ___EmotionJSX(ChevronDownIcon, {
      size: "small"
    }),
    iconPosition: "right",
    onClick: handleViewClick
  }, isOpened ? viewLessLabel : viewMoreLabel)) : ___EmotionJSX("section", null, ___EmotionJSX("div", {
    ref: descriptionRef,
    css: styles.content,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), ___EmotionJSX(Features, {
    features: featureList
  })));
};